<template>
    <Header/>


    <section v-if="$tm('lang') == 'zh'" class="app-feature-area ptb--100" id="feature">
	<div class="container  ptb--100">
		<div class="h5-title section-title">
			<h2>用户协议及隐私条款</h2>
		</div>
		<div class="txt">
		 <p><span style="font-size: 10.5pt; font-family: Arial;">在您使用深圳市频点声学信息技术有限公司Walk Play耳机声音调试工具前，请仔细阅读本《用户协议及隐私条款》（以下简称“本协议”）的全部内容。&nbsp;</span></p>
<p><span style="font-family: Arial;"><span style="font-size: 10.5pt;">说明 本公司向您提供包括但不限于下载、使用、官网查询等服务（以下称“本服务”）。</span></span></p>
<p><span style="font-family: Arial;"><span style="font-size: 10.5pt;">本公
司在此提示用户，请您在使用本服务前详细阅读本协议的所有内容，如您对本协议有任何疑问，请向本公司（0755-86959644，电子邮箱：
stanley.yang@szttgk.com）进行咨询。一旦您使用本服务，即表示您已阅读并完全同意接受本协议项下所述条款和条件的约束。如果您不
同意本协议的任何条款，请您不要使用本服务。</span></span></p>
<p><span style="font-family: Arial;"><span style="font-size: 10.5pt;"><br>
</span></span></p>
<p><span style="font-size: 10.5pt; font-family: Arial;">一、我们可能收集的信息 我们提供服务时，可能会收集、储存和使用下列与您有关的信息。如果您不提供相关信息，可能无法注册成为我们的用户或无法享受我们提供的某些服务，或者无法达到相关服务拟达到的效果。</span></p>
<p><span style="font-family: Arial; font-size: 10.5pt;">（一）您提供的信息</span></p>
<p><span style="font-family: Arial; font-size: 10.5pt;">1、日志信息，指您使用我们的服务
时，系统可能通过cookies、web beacon或其他方式自动采集的技术信息，包括： 
设备或软件信息，例如您的移动设备、网页浏览器或用于接入我们服务的其他程序所提供的配置信息、您的IP地址和移动设备所用的版本和设备识别码；</span></p>
<p><span style="font-family: Arial; font-size: 10.5pt;">2、麦克风权限，指您使用我们服务时，系统会打开麦克风采集的技术信息。</span></p>
<p><span style="font-family: Arial; font-size: 10.5pt;">3、位置信息，指您开启设备定位功能并使用我们基于位置提供的相关服务时，收集的有关您位置的信息，包括：&nbsp; &nbsp;<br>
</span><span style="font-family: Arial; font-size: 10.5pt;">o&nbsp;您或其他用户提供的包含您所处地理位置的实时信息，例如您提供的账户信息中包含的您所在地区信息，您或其他人上传的显示您当前或曾经所处地理位置的共享信息，您或其他人共享的照片包含的地理标记信息；&nbsp; &nbsp; &nbsp;<br>
</span><span style="font-family: Arial; font-size: 10.5pt;">o&nbsp;您通过具有定位功能的移动设备使用我们的服务时，通过GPS或WiFi等方式收集的您的地理位置信息；&nbsp; &nbsp; &nbsp;<br>
</span><span style="font-family: Arial; font-size: 10.5pt;">o&nbsp;您可以通过关闭定位功能，停止对您的地理位置信息的收集。</span></p>
<p><span style="font-family: Arial;"><span style="font-size: 10.5pt;">（二）其他方分享的您的信息 其他方使用我们的服务时所提供有关您的共享信息。</span></span></p>
<p><span style="font-family: Arial;"><span style="font-size: 10.5pt;"><br>
</span></span><span style="font-family: Arial; font-size: 10.5pt;">二、我们如何使用您的信息</span></p>
<p><span style="font-size: 10.5pt; font-family: Arial;">（一）我们可能将在向您提供服务的过程之中所收集的信息用作下列用途：</span></p>
<p><span style="font-size: 10.5pt; font-family: Arial;">1、向您提供服务；</span></p>
<p><span style="font-family: Arial; font-size: 10.5pt;">2、帮助我们设计新服务，改善我们现有服务；</span></p>
<p><span style="font-family: Arial; font-size: 10.5pt;">3、向您提供与您更加相关的广告以替代普遍投放的广告；</span></p>
<p><span style="font-family: Arial; font-size: 10.5pt;">4、评估我们服务中的广告和其他促销及推广活动的效果，并加以改善；</span></p>
<p><span style="font-family: Arial; font-size: 10.5pt;">5、软件认证或管理软件升级；</span></p>
<p><span style="font-family: Arial; font-size: 10.5pt;">（二）为了让您有更好的体验、改善我们的服务或您同意的其他用途，在符合相关法律法规的前提下，我们可能将通过某一项服务所收集的信息，以汇集信息或者个性化的方式，用于我们的其他服务。</span></p>
<p><span style="font-family: Arial; font-size: 10.5pt;"><br>
三、我们如何分享您的信息 除以下情形外，未经您同意，我们以及我们的关联公司不会与任何第三方分享您的个人信息：</span></p>
<p><span style="font-family: Arial; font-size: 10.5pt;">（一）我们以及我们的关联公司，可能将您的个人信息与我们的关联公司、合作伙伴及第三方 服务供应商、承包商及代理（例如代表我们发出电子邮件或推送通知的通讯服务提供商、为我 们提供位置数据的地图服务供应商）分享（他们可能并非位于您所在的法域），用作下列用途：<br>
o&nbsp;向您提供我们的服务；<br>
o&nbsp;实现“我们可能如何使用信息”部分所述目的；<br>
o&nbsp;履行我们在本《隐私条款》或本游戏与您达成的其他协议中的义务和行使我们的权利；<br>
o&nbsp;理解、维护和改善我们的服务。</span></p>
<p><span style="font-family: Arial; font-size: 10.5pt;">（二）随着我们业务的持续发展，我们以及我们的关联公司有可能进行合并、收购、资产转让 或类似的交易，您的个人信息有可能作为此类交易的一部分而被转移。我们将在转移前通知您。</span></p>
<p><span style="font-family: Arial; font-size: 10.5pt;">（三）我们或我们的关联公司还可能为以下需要而保留、保存或披露您的个人信息：<br>
o&nbsp;您授权或同意本游戏披露的；<br>
o&nbsp;遵守适用的法律法规；<br>
o&nbsp;遵守法院命令或其他法律程序的规定；<br>
o&nbsp;遵守相关政府机关的要求；<br>
o&nbsp;为遵守适用的法律法规、维护社会公共利益，或保护我们的客户、我们或我们的集团公司、其他用户或雇员的人身和财产安全或合法权益所合理必需的用途；<br>
o&nbsp;根据本游戏各服务条款及声明中的相关规定，或者本游戏认为必要的其他情形下。</span></p>
<p><span style="font-family: Arial; font-size: 10.5pt;"><br>
四、权利声明</span></p>
<p><span style="font-family: Arial; font-size: 10.5pt;">（一）本公司享有并保留以下各项内容完整的、不可分割的所有权及/或知识产权：<br>
o&nbsp;相关的技术、程序、代码、界面等；<br>
o&nbsp;本服务相关的商标、图形标记。<br>
o&nbsp;本公司提供的服务内容中所涉及图片、图表等，均受相关知识产权法以及其他相关法律的保护。未经本公司或者其他相关权利人授权，用户不得复制、使用、修改、摘编、翻译、发行,第三方未经本公司及/或其相关权利人的书面许可，不得以任何方式擅自进行使用。</span></p>
<p><span style="font-family: Arial; font-size: 10.5pt;"><br>
五、责任限制</span></p>
<p><span style="font-family: Arial; font-size: 10.5pt;">1、本公司向用户提供的服务均是在依\"现状\"提供，本公司在此明确声明对本服务不作任何明示或暗示的保证，包括但不限于对服务的可适用性、准确性、及时性、可持续性等。&nbsp;</span></p>
<p><span style="font-family: Arial; font-size: 10.5pt;">2、用户理解并同意自行承担使用本服务的风险，且用户在使用本服务时，应遵循中国法律的相关规定，由于用户行为所造成的任何损害和后果，本公司均不承担除法律有明确规定外的责任。&nbsp;</span></p>
<p><span style="font-family: Arial; font-size: 10.5pt;">3、不论在何种情况下，本公司均不对由于网络连接故障、通讯线路、第三方网站、电脑硬件等任何原因给用户造成的任何损失承担除法律有明确规定外的责任。&nbsp; &nbsp;</span></p>
<p><span style="font-family: Arial; font-size: 10.5pt;"><br>
六、用户行为规范</span></p>
<p><span style="font-family: Arial; font-size: 10.5pt;">1、用户在使用本服务时须遵守法律法规，不得利用本服务从事违法违规行为，包括但不限于：</span></p>
<p><span style="font-family: Arial; font-size: 10.5pt;">（1）发布、传送、传播、储存危害国家安全统一、破坏社会稳定、违反公序良俗、侮辱、诽谤、淫秽、暴力以及任何违反国家法律法规的内容；&nbsp;</span></p>
<p><span style="font-family: Arial; font-size: 10.5pt;">（2）发布、传送、传播、储存侵害他人知识产权、商业秘密等合法权利的内容；</span></p>
<p><span style="font-family: Arial; font-size: 10.5pt;">（3）恶意虚构事实、隐瞒真相以误导、欺骗他人；</span></p>
<p><span style="font-family: Arial; font-size: 10.5pt;">（4）发布、传送、传播广告信息及垃圾信息；</span></p>
<p><span style="font-family: Arial; font-size: 10.5pt;">（5）其他法律法规禁止的行为。</span></p>
<p><span style="font-family: Arial; font-size: 10.5pt;">2、用户不得利用本服务进行任何有损本公司之权利、利益及商誉，或其他用户合法权利之行为。</span></p>
<p><span style="font-family: Arial; font-size: 10.5pt;">3、用户不得基于本服务从事制作、使用、传播“私服”、“外挂”等侵害本公司合法权益的行为。如有违反，本公司将依据中国现行法律法规及本公司的相关规定予以处理。&nbsp;</span></p>
<p><span style="font-family: Arial; font-size: 10.5pt;">4、用户不得从事任何利用本公司平台系统漏洞进行有损其他用户、本公司或互联网安全的行为。</span></p>
			 
 
		</div>
	</div>
</section>

<section v-if="$tm('lang') == 'en'" class="app-feature-area ptb--100" id="feature">
	<div class="container  ptb--100">
		<div class="h5-title section-title">
			 
			<h2>User Agreement and Privacy Terms</h2>
		</div>
		<div class="txt">
		 <p class="MsoNormal"><span style="font-family: 楷体;"><b><span style="font-size: 12pt;">User Agreement and Privacy Terms</span></b></span></p>
<p class="MsoNormal"><span style="font-family: 楷体;"><b><span style="font-size: 12pt;"><br>
</span></b></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><o:p></o:p></span></p>
<p class="MsoNormal"><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><font face="Calibri">Before using the Walk 
Play headset sound tuning tool provided by Shenzhen PinDianShengXue Technology Co.,
 Ltd. Please read the entire contents of this "User Agreement and 
Privacy Terms" (hereinafter referred to as "this Agreement") carefully. </font></span></p>
<p class="MsoNormal"><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><font face="Calibri">Description Our company
 offers you services including but not limited to download, use, and 
official website inquiry (hereinafter referred to as "the Service"). </font></span></p>
<p class="MsoNormal"><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><font face="Calibri">We hereby remind users 
to read all the contents of this Agreement in detail before using the 
Service. If you have any questions about this Agreement, please consult 
our company (0755-86959644, email: stanley.yang@szttgk.com). Once you 
use the Service, it indicates that you have read and fully agree to be 
bound by the terms and conditions described under this Agreement. If you
 do not agree to any terms of this Agreement, please do not use the 
Service.</font></span></p>
<p class="MsoNormal">&nbsp;</p>
<p class="MsoNormal"><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><font face="Calibri">Information We May 
Collect When providing the Service, we may collect, store, and use the 
following information related to you. If you do not provide relevant 
information, you may not be able to register as our user, enjoy some of 
the services we offer, or achieve the intended effects of related 
services. </font></span></p>
<p class="MsoNormal"><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><font face="Calibri">(1) Information you provide: </font></span></p>
<p class="MsoNormal"><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><font face="Calibri">1. Log information, 
refers to technical information that the system may automatically 
collect through cookies, web beacons, or other means when you use our 
services, including: Device or software information, such as the 
configuration information provided by your mobile device, web browser, 
or other programs used to access our services, your IP address, and the 
version and device identification code of your mobile device.</font></span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;">2. Microphone permission, refers to the technical information collected by the system when using our services.</span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;">
 3. Location information, refers to the information about your location 
collected when you enable the device's positioning function and use our 
location-based services, including:<br>
</span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;">3.1
 Real-time information provided by you or other users that includes your
 geographical location, such as the region information in your account 
information, the shared information uploaded by you or others that shows
 your current or past geographical location, and the geographic tag 
information contained in the photos shared by you or others. </span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;">3.2
 Your geographical location information collected through GPS or WiFi, 
etc., when you use our services with a mobile device that has 
positioning capabilities.] </span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;">3.3 You can stop the collection of your geographical location information by turning off the positioning function. </span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;">(2) Information shared by others about you: Shared information about you provided by others when they use our services. </span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;"><br>
How We Use Your Information </span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;">(1) The information we collect during the provision of services to you may be used for the following purposes: </span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;">1. To provide services to you. </span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;">2. To help us design new services and improve our existing services. </span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;">3. To offer you more relevant advertisements in place of general ad placements. </span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;">4. To evaluate and improve the effectiveness of advertisements and other promotional and marketing activities in our services. </span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;">5. For software verification or management of software upgrades. </span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;">(2)
 To give you a better experience, improve our services, or for other 
purposes you agree to, within the limits of relevant laws and 
regulations, we may use the information collected through a particular 
service in an aggregated or personalized manner for our other services. </span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;"><br>
</span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;">How
 We Share Your Information Except for the following circumstances, 
without your consent, we and our affiliates will not share your personal
 information with any third parties: </span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;">(1)
 We and our affiliates may share your personal information with our 
affiliates, partners, and third-party service providers, contractors, 
and agents (for example, communication service providers who send emails
 or push notifications on our behalf, map service providers who provide 
us with location data) (they may not be located in your jurisdiction) 
for the following purposes: </span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;">1. To provide you with our services. </span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;">2. To achieve the purposes described in the "How We Use Your Information" section. </span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;">3. To fulfill our obligations and exercise our rights under this "Privacy Terms" or other agreements we have reached with you. </span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;">4. To understand, maintain, and improve our services. </span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;">(2)
 As our business continues to develop, we and our affiliates may merge, 
be acquired, transfer assets, or undergo similar transactions, and your 
personal information may be transferred as part of such transactions. We
 will notify you before the transfer. </span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;">(3) We or our affiliates may also retain, save, or disclose your personal information for the following needs: </span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;">1. Disclosed by this game with your authorization or consent.</span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;"> 2. To comply with applicable laws and regulations. </span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;">3. To comply with court orders or other legal processes.</span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;"> 4. To comply with the demands of relevant government agencies. </span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;">5.
 To comply with applicable laws and regulations, maintain public 
interests of society, or protect the personal and property safety or 
legal rights of our customers, us or our group companies, other users, 
or employees as reasonably necessary. According to the relevant 
provisions of the service terms and statements of this game, or other 
situations that this game deems necessary.<br>
</span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;"><br>
</span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;">Rights Statement </span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;">(1) Our company owns and retains complete, indivisible ownership and/or intellectual property rights in the following contents:</span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;"> 1. Related technology, programs, codes, interfaces, etc..</span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;"> 2. Trademarks, graphic marks related to the service. </span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;">3.
 Images, charts, etc., involved in the content provided by our services 
are protected by relevant intellectual property laws and other laws. 
Without authorization from our company or other relevant rights holders,
 users may not copy, use, modify, compile, translate, distribute. Third 
parties may not use them in any way without written permission from our 
company and/or its relevant rights holders. </span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;"><br>
Limitation of Liability </span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;">The
 services provided by our company to users are provided "as is", and 
hereby, our company expressly disclaims any express or implied 
warranties, including but not limited to the applicability, accuracy, 
timeliness, sustainability, etc., of the services. </span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;">Users
 understand and agree to bear the risks of using the service themselves,
 and when using the service, they should comply with the relevant 
provisions of Chinese law.</span><span style="font-family: Calibri; font-size: 10.5pt;">Our
 company does not bear any responsibility other than those explicitly 
stipulated by law for any damage and consequences caused by user 
behavior.</span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;">Under
 no circumstances will our company be responsible for any loss caused to
 users due to network connection failures, communication lines, 
third-party websites, computer hardware, and any other reasons other 
than those explicitly stipulated by law. </span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;"><br>
User Behavior Standards</span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;">Users
 must comply with laws and regulations when using the Service and shall 
not use the Service to engage in illegal or rule-violating behaviors, 
including but not limited to: </span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;">(1)
 Publishing, transmitting, spreading, storing content that endangers 
national security unity, destroys social stability, violates public 
order and morals, insults, defames, is obscene, violent, and any content
 that violates national laws and regulations.</span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;">
 (2) Publishing, transmitting, spreading, storing content that infringes
 on the intellectual property rights, trade secrets, and other lawful 
rights of others. </span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;">(3) Maliciously fabricating facts, concealing the truth to mislead or deceive others. </span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;">(4) Publishing, transmitting, spreading advertising information and spam.</span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;"> (5) Other behaviors prohibited by laws and regulations.</span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;">
 Users shall not engage in any actions that harm the rights, interests, 
and reputation of the company or the legal rights of other users. </span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;">Users
 shall not engage in the production, use, dissemination of "private 
servers", "plugins" and other actions that infringe on the legitimate 
rights and interests of the company based on the Service.</span><span style="font-family: Calibri; font-size: 10.5pt;">If
 violated, the company will deal with it according to the current laws 
and regulations of China and the relevant regulations of the company.</span></p>
<p class="MsoNormal"><span style="font-family: Calibri; font-size: 10.5pt;">Users
 shall not engage in any actions that exploit the platform system 
vulnerabilities of the company to harm other users, the company, or 
internet security.<font class="notranslate immersive-translate-target-wrapper" translate="no" lang="zh-CN" data-immersive-translate-loading-id="31">&nbsp; </font></span><font class="notranslate immersive-translate-target-wrapper" translate="no" lang="zh-CN" data-immersive-translate-loading-id="18" style="font-family: Calibri; font-size: 10.5pt;">&nbsp;&nbsp;</font></p>
<p class="MsoNormal"><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Calibri;
mso-hansi-font-family:Calibri;mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><o:p></o:p></span></p>
			 
 
		</div>
	</div>
</section>

    <Footer :lang="lang"/>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import { useI18n } from 'vue-i18n';

export default {
  name: 'Home',
  components: {
    Header,
    Footer
  },
  setup(){
    document.title = "Walk Play";
    const { tm, locale } = useI18n();
    return {
      tm
    }
  },
  data(){
    return {
      lang: "cn"
    }
  },
  methods: {
    changeLang(lang){
      this.lang = lang;
    }
  }
}
</script>
